module.exports = __webpack_public_path__ + "img/device_model.3b64deba.svg";